// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__Xv0Vt","title":"style_title__oFY+v","rightDiv":"style_rightDiv__6jGPx"};